import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { oldEmail, oldPassword } from '../../core/models/messages';
import { patternEmail, patternPassword } from '@core/models/pattern';
import { AuthService } from '@core/services/auth-service/auth.service';
import { FournisseurService } from '@core/services/fournisseur-service/fournisseur.service';
import { LocalStorageService } from '@core/services/local-storage.service';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-change-email',
  templateUrl: './change-email.component.html',
  styleUrls: ['./change-email.component.css']
})
export class ChangeEmailComponent {
  /* generate email control */
  currentUser = this.localStorageService.getData('UserInfo');

  EmailForm: FormGroup = this.emailForm();

  /* boolean */
  loadSpinner: boolean = false;
  showPassword: boolean = false;
  emailError: boolean = false;
  /* unsubscription */
  private unsubscribeAll: Subject<void> = new Subject();
  constructor(private formBuilder: FormBuilder,
    private authService: AuthService,
    private companyService:FournisseurService,
    private localStorageService: LocalStorageService,
    private toastrService: ToastrService,


  ) {
  }

  emailForm() {

    return this.formBuilder.group({
      old_email: [{ value: JSON.parse(this.currentUser!).email, disabled: true }
        ,
        [
          Validators.required,
          Validators.email,
          Validators.pattern(patternEmail),
        ],
      ],
      new_email: [''
        ,
        [
          Validators.required,
          Validators.email,
          Validators.pattern(patternEmail),
        ],
      ],
      password: [
        '',
        [Validators.required, Validators.pattern(patternPassword)],
      ],
    });
  }

  checkEmailMatch() {
    const newEmail = this.EmailForm.get('new_email')?.value;
    const oldEmail = this.EmailForm.get('old_email')?.value;

    if (newEmail && newEmail === oldEmail) {
      this.emailError = true;
    } else {
      this.emailError = false;
    }
  }

  MailChange() {
    if (this.EmailForm.valid) {

      this.loadSpinner = true;
      const data ={
        new_email: this.EmailForm?.get('new_email')?.value,
        password: this.EmailForm?.get('password')?.value,

      }
      this.companyService
        .changeEmail(data)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res: { status: number; data: any }) => {
            if (res.status == 200) {
              this.loadSpinner = true;
              this.authService.logOut()
            }
          },
          error: (err: any) => {
            this.loadSpinner = false;
            if (err.error.message == "Old password is incorrect") {
              this.toastrService.error(oldPassword);
            }
            if (err.error.message?.new_email[0] == "The new_email has already been taken.") {
              this.toastrService.error(oldEmail);
            }
          
          },
        });
    }
  }
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
